import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { label: "实时热榜", href: "#ranking" },
  { label: "热门话题", href: "#topics" },
  { label: "话题分类", href: "#categories" },
  { label: "深度围观", href: "#dive" },
  { label: "常见问题", href: "#faq" },
  { label: "网站口碑", href: "#voice" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkClass = scrolled
    ? "text-foreground-700 hover:text-primary-600"
    : "text-background-100 hover:text-background-50";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "bg-gradient-to-b from-foreground-950/50 to-transparent"
      }`}
    >
      <div className="flex h-16 items-center justify-between px-4 md:h-[72px] md:px-8">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-bold tracking-wide ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              网曝吃瓜
            </span>
            <span
              className={`mt-0.5 text-[10px] tracking-[0.24em] ${
                scrolled ? "text-foreground-500" : "text-background-200"
              }`}
            >
              热点围观现场
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${linkClass}`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            订阅热点
          </a>
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((prev) => !prev)}
            className={`flex h-10 w-10 items-center justify-center rounded-md transition-colors lg:hidden ${
              scrolled
                ? "text-foreground-800 hover:bg-background-200"
                : "text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between border-b border-background-200/70 py-3 text-sm font-medium text-foreground-800"
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />
              </a>
            ))}
          </nav>
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-4 flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
          >
            订阅热点
          </a>
        </div>
      ) : null}
    </header>
  );
}